/**
 * @file 入口
 * @author wangzhuang
 */
import secm from '@baidu/sec-monitor';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {createStore, combineReducers} from 'redux';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import App from './App.tsx';
import {ConfigProvider} from 'antd';

import {extendComponent} from './util';
import * as serviceWorker from './serviceWorker';
// import {WeirwoodErrorBoundary} from './WeirwoodErrorBoundary';
import moment from 'moment';
import locale from 'antd/es/locale/zh_CN';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

import reducers from './reducers';
import './index.less';
window.addEventListener('error', error => {
    secm.error(error);
}, true);
const todoApp = combineReducers(reducers);
const store = createStore(todoApp);
extendComponent()();

ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider locale={locale}>
            <BrowserRouter>
                {/* <WeirwoodErrorBoundary> */}
                <App />
                {/* </WeirwoodErrorBoundary> */}
            </BrowserRouter>
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
